module.exports = __webpack_public_path__ + "static/img/img_mobile_app.b81b5c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_mobile_app.png
// module id = g71y
// module chunks = 3